import Vue from 'vue'
import Vuex from 'vuex'
import { q2o, formatUserInfo } from '../common/utils';

import mutations from './mutations/index'
import actions from './actions/index'
import getters from './getters/index'
import modules from './modules/index'



Vue.use(Vuex)

// 活动ID
const query = q2o(location.search.slice(1))
const _WZMatch_ = window._WZMatch_ || {}
const Urls = _WZMatch_.Urls || {}
const cId = +query.cId || +_WZMatch_.cId || 2  // 默认为2

const myAccount = window._WZAccount_ || null

const state = {
  // 底导航
  pageName: 'index',
  hasTabbar: true,  // 显示
  idxTabbar: 0, // 当前序号

  // configs
  cId: cId,  // 活动ID
  configInfo: null,
  blockMap: null,
  // blockList: [],
  cupList: null, 
  _cupMap: null,

  // timer
  _nowTime: 0,
  timer: null,
  timeMap: null,

  // my
  myUid: myAccount ? myAccount.uid : 0,
  myInfo: myAccount ? formatUserInfo(myAccount) : null,
  myDetail: null,
  myAwards: null,
  myAddress: null,

  //
  _myDkGames: null,
  _myDkCupPlayers: null,

  // address,
  _addressMap: null,
  _addressTree: null, // {pid: [id, id, id ...]}

  // 第三方账号绑定地址
  oauthAddress: null,
  myOpenId: '',
  myOpenNick: '',

  Urls
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules
})
